export default "__VITE_ASSET__819933c5__"